<template>
	<div class="sidebar-macro-button-container" :class="{active, locked, manual: userStore.manualCode}" @click="$emit('button-click')" :style="'--icon-color: '+(iconColor ? iconColor : '#fff')">
		<div class="macro-button" v-html="iconHTML">
		</div>
		<div v-if="locked" class="lock-icon" v-html="getIcon('iconLock')"></div>
		<div v-else-if="warning" class="warning-icon" v-html="getIcon('iconBell')"></div>
	</div>
</template>

<script>
import {useSvgStore} from "@/shared/stores";
import {useUserStore} from "@/console-new/stores";

export default {
	setup() {
		const svgStore = useSvgStore();
		const userStore = useUserStore();
		return {
			getIcon: svgStore.get,
			userStore
		}
	},
	name: "SidebarMacroButton",
	emits: ["button-click"],
	props: {
		active: {
			type: Boolean,
			default: false
		},
		locked: {
			type: Boolean,
			default: false
		},
		warning: {
			type: Boolean,
			default: false
		},
		iconName: {
			type: String,
			required: true
		},
		iconColor: {
			type: String,
			default: null
		}
	},
	computed: {
		iconHTML() {
			//if iconName is a valid URL, return it as data URI, otherwise get it from svgStore
			if (this.iconName && this.iconName.startsWith('https')) {
				return `<img src="${this.iconName}" alt="icon" />`;
			} else {
				return this.getIcon(this.iconName);
			}
		}
	}
}
</script>

<style lang="scss" scoped>

.sidebar-macro-button-container {
	display: flex;
	position: relative;
	cursor: pointer;
	pointer-events: all;
	width: 40px;
	height: 40px;
	transition: background-color 0.2s $transition, box-shadow 0.2s $transition;
	margin: 0 auto;
	border-radius: 10px;

	&:hover {
		background-color: rgba(255, 255, 255, 0.16);
	}

	&:after {
		content: "";
		position: absolute;
		top: 0;
		right: 0;
		width: 25px;
		height: 100%;
		background-color: var(--color-bg-sidebar);
		border-radius: 20px;
		z-index: -1;
		cursor: default;
		transition: right .4s $transition;
	}

	&:deep(svg) {
		width: 17px;

		.fill {
			fill: var(--icon-color);
		}
		.stroke {
			stroke: var(--icon-color);
		}
	}

	&.locked {
		background: rgba(0,0,0,.25) 0% 0% no-repeat padding-box;
		box-shadow: inset 0 2px 3px rgba(0, 0, 0, 0.2509803922);

		&:deep(svg) {
			.fill { fill: $primary; }
			.stroke { stroke: $primary; }
		}
	}

	&.active {
		box-shadow: inset 0 2px 3px #00000040;
		background-color: rgba(0, 0, 0, 0.12);

		&:deep(svg) {

			.fill {
				fill: $secondary;
			}
			.stroke {
				stroke: $secondary;
			}
		}

		&:after {
			right: -9px;
		}

	}

	&.manual {
		background-color: var(--color-manual-4);
		&:after {
			background-color: var(--color-manual-1);
		}
	}

	& * {
		@include noSelect();
		pointer-events: none;
	}

	.macro-button {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;

		:deep(img) {
			width: 100%;
			height: 100%;
			object-fit: cover;
			border-radius: 10px;
			box-shadow: -0.5px -0.5px 1px 0 rgba(0, 0, 0, 0.25) inset, 0.5px 0.5px 1px 0 rgba(255, 255, 255, 0.43) inset;
			padding: 5px;
		}
	}

	.lock-icon {
		@include centered;
		position: absolute;
		top: -2px;
		right: -2px;
		width: 14px;
		height: 14px;
		border-radius: 50%;
		background: var(--color-txt-white);
		border: 2px solid var(--color-bg-sidebar);

		&:deep(svg) {
			width: 7px;
			height: 7px;
			margin-bottom: 1px;
		}
	}

	.warning-icon {
		@include centered;
		position: absolute;
		top: -2px;
		right: -2px;
		width: 14px;
		height: 14px;
		border-radius: 50%;
		background: #e83d15;
		border: 2px solid var(--color-bg-sidebar);

		&:deep(svg) {
			width: 7px;
			height: 7px;
			margin-bottom: 1px;

			.fill {
				fill: var(--color-txt-white);
			}

			.stroke {
				stroke: var(--color-txt-white);
			}
		}
	}

}
</style>